// extracted by mini-css-extract-plugin
export default {"odds_by":"competitor-standings-page_odds_by__qAeMP","small_view":"competitor-standings-page_small_view__AwszI"};